// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaveapplyfirstdiv{
    font-family: "Inter";
font-size: 18px;
font-weight: 600;
text-align: left;
align-items: center;
color: #0070E9;
/* padding-left: 2%; */
/* padding-top: 2%; */

}

.leavereqSelectedTotalMain{
    justify-content: center;
    text-align: center;
    align-items: center;
    margin: auto;
    
}

.leavereqSelectDates{
    font-family: "Inter";
font-size: 16px;
font-weight: 600;
line-height: 21.78px;
letter-spacing: 0.02em;
text-align: left;
color:#002C5D;
justify-content: center;
text-align: center;

}

.leftarrowinapply{
    width: 6px !important;
height: 12px !important;
top: 6px;
left: 9px;
gap: 0px;
font-size: 12px !important;
border: 2px 0px 0px 0px;

 color:#002C5D !important;
cursor:pointer
}

.headinginfromInapply1{
    color: #0070E9 !important;
    font-family:"Inter";
font-size: 16px;
font-weight: 600;
line-height: 19.36px;
text-align: center;
align-items: center !important;
/* padding-top: 3%; */
}

.fromInapply1{
    font-family: "Inter";
font-size: 16px;
font-weight: 600;
line-height: 19.36px;
text-align: center;
color:#002C5D ;
align-items: center !important;
}

.leaveApplyTotaldaysMain{
    display: flex;
    gap:2%;
    align-items: center;
    text-align: center;
    justify-content: center;


}

.leaveApplyTotaldaystotal{
    font-family: "Inter";
font-size: 16px;
font-weight: 600;
/* line-height: 19.36px; */
text-align: left;
color:#002C5D;
justify-content: center;
text-align: center;

}

.leavereqTotalDays{
    font-family: "Inter";
font-size: 20px;
font-weight: 600;
line-height: 24.2px;
text-align: left;
color:#0070E9;


}

.leavereq2ndiv3rdcol{
    display:flex;
    gap:4%;
    align-items: center;
    justify-content: center;
    text-align: center;

}

.levreqDate{
    font-family: "Inter";
font-size: 16px;
font-weight: 700;
line-height: 19.36px;
text-align: left;
color:#0070E9;


}


.calenderreactmain{
    display: flex;
    gap:4%;
    justify-content: center;
    text-align: center;
    align-items: center;
    margin: auto;
    padding-top: 5%;
    /* padding-bottom: 3%; */
    

}

.react-calendar { 
    width: 100%;
    max-width: 420px;
    background-color: #fff;
    color: #222;
    border-radius: 8px;
    /* box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2); */
    font-family: Arial, Helvetica, sans-serif;
    line-height: 1.125em;
    /* border: none !important; */
    border:1px solid #E9E9E9;
    padding: 10px;

   }
   .react-calendar__navigation button {
    color: #6f48eb;
    min-width: 44px;
    background: none;
    font-size: 16px;
    margin-top: 8px;
   }
   .react-calendar__navigation button:enabled:hover,
   .react-calendar__navigation button:enabled:focus {
    background-color: #f8f8fa;
   }
   .react-calendar__navigation button[disabled] {
    background-color: #f0f0f0;
   }
   abbr[title] {
    text-decoration: none;
   }
   /* .react-calendar__month-view__days__day--weekend {
    color: #d10000;
   } */
   .react-calendar__tile:enabled:hover,
   .react-calendar__tile:enabled:focus {
    background: #f8f8fa;
    color: #6f48eb;
    border-radius: 6px;
   }
   .react-calendar__tile--now {
    background: #6f48eb33;
    border-radius: 6px;
    font-weight: bold;
    color: #6f48eb;
   }
   .react-calendar__tile--now:enabled:hover,
   .react-calendar__tile--now:enabled:focus {
    background: #6f48eb33;
    border-radius: 6px;
    font-weight: bold;
    color: #6f48eb;
   }
   .react-calendar__tile--hasActive:enabled:hover,
   .react-calendar__tile--hasActive:enabled:focus {
    background: #f8f8fa;
   }
   .react-calendar__tile--active {
    background: #6f48eb;
    border-radius: 6px;
    font-weight: bold;
    color: white;
   }
   .react-calendar__tile--active:enabled:hover,
   .react-calendar__tile--active:enabled:focus {
    background: #6f48eb;
    color: white;
   }
   .react-calendar--selectRange .react-calendar__tile--hover {
    background-color: #f8f8fa;
   }
   .react-calendar__tile--range {
    background: #f8f8fa;
    color: #6f48eb;
    border-radius: 0;
   }
   .react-calendar__tile--rangeStart {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    background: #6f48eb;
    color: white;
   }
   .react-calendar__tile--rangeEnd {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    background: #6f48eb;
    color: white;
   }

   .react-calendar__month-view__weekdays{
    font-family: "Inter";
font-size: 12px;
font-weight: 500;
line-height: 12px;
letter-spacing: 0.03em;
text-align: left;
color:#00162E

   }



   .react-calendar__month-view__days__day--weekend{
    font-family: "Inter";
font-size: 12px;
font-weight: 500;
line-height: 22px;
text-align: center;
color:#E90000;
background-color: #E9000033;
border-radius: 100%;
padding-top: 10px;
padding-bottom: 10px;


   }

   .react-calendar__month-view__days{
    padding-top: 5px;
    padding-bottom: 10px;
   }
   .react-calendar__navigation__arrow.react-calendar__navigation__prev-button{
    color:#002C5D;
    font-size:12px;
   }

   .react-calendar__month-view__days button{
    height:44px;
    /* width:100%; */
    width: 40px;
    margin-top: 5px;
    border-radius: 50%;
   }


   .colors-label-detailing{
    display: flex;
    /* text-align: center; */
    align-items: center;
    justify-content: center;
    /* padding-left: 3%; */
   }

   .Selected-Leavegrid{
    font-family: "Inter";
font-size: 14px;
font-weight: 700;
line-height: 16.94px;
letter-spacing: 0.02em;
text-align: left;
color:#0070E9

   }
   .privilizedleavegrid{
    font-family: "Inter";
    font-size: 14px;
    font-weight: 700;
    line-height: 16.94px;
    letter-spacing: 0.02em;
    text-align: left;
    color:#008A27

   }

   .Optinalleavegrid{
    font-family: "Inter";
    font-size: 14px;
    font-weight: 700;
    /* line-height: 16.94px; */
    letter-spacing: 0.02em;
    text-align: left;
    justify-content: left;
    color:grey

   }
   .Sick-Leave-grid{
    font-family: "Inter";
    font-size: 14px;
    font-weight: 700;
    line-height: 16.94px;
    letter-spacing: 0.02em;
    text-align: left;
    color:#E97000;
    margin-left: 0;


   }

   .Holidaygrid{
    font-family: "Inter";
    font-size: 14px;
    font-weight: 700;
    line-height: 16.94px;
    letter-spacing: 0.02em;
    text-align: left;
    color:#E90000

   }

   .react-calendar button {
    font-family: "Inter";
font-size: 18px;
font-weight: 500;
line-height: 22px;
text-align: center;
width:19px;
/* color:#00162E; */
/* margin: 10px; */

   }




   /* new */


.LeaveApplyCalenderContainer{
    display: flex;
    justify-content: space-around;
    gap: 10px;
}
   .calendarInapply {
    /* display: flex;
    justify-content: space-around;
    flex-direction: row; */
    align-items: center;
    border: 1px solid #E9E9E9;
    /* margin:10px; */
    width:40%
}

.calendar-headerInapply1 {
    display: flex;
    /* width: 100%; */
    justify-content: space-around;
    /* background-color: #f0f0f0; */
    padding: 10px;
    align-items: center !important;
}

.calendar-header-dayInapply1 {
    width: 12.28%;
    text-align: center;
    font-weight: bold;
}

.calendar-bodyInapply1 {
    display: flex;
    flex-direction: column;
    width: 100%;
    /* height:100vh; */
}

.calendar-weekInapply1 {
    display: flex;
    width: 100%;
    height: 50px;
    /* padding-bottom: 1%; */
}



.calendar-dayInapply1 :hover{
    border: 1px solid #0070E9;
    background-color: grey;
    cursor: pointer;
}




.calendarInapply2 {
    /* display: flex;
    justify-content: space-around;
    flex-direction: column; */
    align-items: center;
    border: 1px solid #E9E9E9;
    /* margin:10px; */
    width:40%
}

.calendar-headerInapply2 {
    display: flex;
    width: 100%;
    justify-content: space-around;
    /* background-color: #f0f0f0; */
    padding: 10px;
}

.calendar-header-dayInapply2 {
    width: 7.14%;
    text-align: center;
    font-weight: bold;
}

.calendar-bodyInapply2 {
    display: flex;
    flex-direction: column;
    width: 100%;
    /* height:100vh; */
}

.calendar-weekInapply2 {
    display: flex;
    width: 100%;
}

.calendar-dayInapply1 {
    width: 12.28%;
    height: 47px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /* border: 1px solid #f0f0f0; */
    position: relative;
    transition: background-color 0.3s;
    border-radius: 100px;
    margin-top: 10px;
    gap: 10px;
    margin-right: 5px;
    margin-bottom: 3%;
    margin: 0 auto;
}
.calendar-dayInapply12{
width: 12.28%;
height: 47px;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
/* border: 1px solid #f0f0f0; */
position: relative;
transition: background-color 0.3s;
border-radius: 100px;
margin-top: 10px;
gap: 10px;
margin-right: 5px;
margin-bottom: 3%;
margin: 0 auto;
}

.calendar-dayInapply12 {
    width: 12.28%;
    height: 47px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /* border: 1px solid #f0f0f0; */
    position: relative;
    transition: background-color 0.3s;
    border-radius: 100px;
    margin-top: 10px;
    gap: 10px;
    margin-right: 5px;
    margin-bottom: 3%;
    margin: 0 auto;
}

.weekendInapply1 {
    background-color: #E9000033;
    color:#E90000;
}

.holidayInapply1 {
    background-color: #008A2733;
    color:#008A27

}

.holiday-nameInapply1 {
    position: absolute;
    bottom: 5px;
    font-size: 0.75em;
    text-align: center;
    width: 100%;
}

.calendar-dayInapply1:hover {
    border: 1px solid #0070E9;
    /* background-color: rgb(192, 187, 187); */
    cursor: pointer;
}

/* Adjust specificity if needed */
.calendar-dayInapply1.selected {
    background-color: #0070E9;
    color: white;
}
.modalButtonContainer{
    justify-content: center;
    display: flex;
    text-align: center;
    /* gap: 3% !important; */
    margin-top: 4%;
}
.leaveApplyModalConfirm{
    font-family: "Inter" !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    background-color: #FE602F !important;
    border: none !important;
    color:white !important;
    text-transform: none !important;
}
.leaveApplyModalCancel{
    font-family: "Inter" !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    background-color: white !important;
    border: none !important;
    color:#FE602F !important;
    border: 1px solid #FE602F !important;
    text-transform: none !important;
}

  
.modalselectedDates{
    background-color: #f7fbff;
    border-radius: 10px;
    border: 1px dashed #dce4ed;
    padding: 20px;
    width:100%;
    text-align: center;
    max-height: 650px;
    overflow-y: auto;
}

.labelforselectDates{
    font-family: "Inter";
    font-size: 16px;
    font-weight: 550;
    line-height: 19px;
    /* letter-spacing: 0.02em; */
    text-align: left;
    color:#0056B2;
    padding-left: 10px;
    /* padding-bottom: 5px; */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

`, "",{"version":3,"sources":["webpack://./src/views/panel/LeaveManagement/LeaveApply/LeaveApply.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,gBAAgB;AAChB,mBAAmB;AACnB,cAAc;AACd,sBAAsB;AACtB,qBAAqB;;AAErB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;;AAEhB;;AAEA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,sBAAsB;AACtB,gBAAgB;AAChB,aAAa;AACb,uBAAuB;AACvB,kBAAkB;;AAElB;;AAEA;IACI,qBAAqB;AACzB,uBAAuB;AACvB,QAAQ;AACR,SAAS;AACT,QAAQ;AACR,0BAA0B;AAC1B,uBAAuB;;CAEtB,wBAAwB;AACzB;AACA;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,kBAAkB;AAClB,8BAA8B;AAC9B,qBAAqB;AACrB;;AAEA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,kBAAkB;AAClB,cAAc;AACd,8BAA8B;AAC9B;;AAEA;IACI,aAAa;IACb,MAAM;IACN,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;;;AAG3B;;AAEA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,0BAA0B;AAC1B,gBAAgB;AAChB,aAAa;AACb,uBAAuB;AACvB,kBAAkB;;AAElB;;AAEA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,mBAAmB;AACnB,gBAAgB;AAChB,aAAa;;;AAGb;;AAEA;IACI,YAAY;IACZ,MAAM;IACN,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;;AAEtB;;AAEA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,gBAAgB;AAChB,aAAa;;;AAGb;;;AAGA;IACI,aAAa;IACb,MAAM;IACN,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,wBAAwB;;;AAG5B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,gDAAgD;IAChD,yCAAyC;IACzC,oBAAoB;IACpB,6BAA6B;IAC7B,wBAAwB;IACxB,aAAa;;GAEd;GACA;IACC,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,eAAe;GAChB;GACA;;IAEC,yBAAyB;GAC1B;GACA;IACC,yBAAyB;GAC1B;GACA;IACC,qBAAqB;GACtB;GACA;;MAEG;GACH;;IAEC,mBAAmB;IACnB,cAAc;IACd,kBAAkB;GACnB;GACA;IACC,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;GACf;GACA;;IAEC,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;GACf;GACA;;IAEC,mBAAmB;GACpB;GACA;IACC,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;GACb;GACA;;IAEC,mBAAmB;IACnB,YAAY;GACb;GACA;IACC,yBAAyB;GAC1B;GACA;IACC,mBAAmB;IACnB,cAAc;IACd,gBAAgB;GACjB;GACA;IACC,0BAA0B;IAC1B,6BAA6B;IAC7B,2BAA2B;IAC3B,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;GACb;GACA;IACC,yBAAyB;IACzB,4BAA4B;IAC5B,4BAA4B;IAC5B,+BAA+B;IAC/B,mBAAmB;IACnB,YAAY;GACb;;GAEA;IACC,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,sBAAsB;AACtB,gBAAgB;AAChB;;GAEG;;;;GAIA;IACC,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,kBAAkB;AAClB,aAAa;AACb,2BAA2B;AAC3B,mBAAmB;AACnB,iBAAiB;AACjB,oBAAoB;;;GAGjB;;GAEA;IACC,gBAAgB;IAChB,oBAAoB;GACrB;GACA;IACC,aAAa;IACb,cAAc;GACf;;GAEA;IACC,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,kBAAkB;GACnB;;;GAGA;IACC,aAAa;IACb,wBAAwB;IACxB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;GACvB;;GAEA;IACC,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,sBAAsB;AACtB,gBAAgB;AAChB;;GAEG;GACA;IACC,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB;;GAED;;GAEA;IACC,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,sBAAsB;IACtB,gBAAgB;IAChB,qBAAqB;IACrB;;GAED;GACA;IACC,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,cAAc;;;GAGf;;GAEA;IACC,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB;;GAED;;GAEA;IACC,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,kBAAkB;AAClB,UAAU;AACV,mBAAmB;AACnB,kBAAkB;;GAEf;;;;;GAKA,QAAQ;;;AAGX;IACI,aAAa;IACb,6BAA6B;IAC7B,SAAS;AACb;GACG;IACC;;0BAEsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,6BAA6B;IAC7B,+BAA+B;IAC/B,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,wBAAwB;AAC5B;;;;AAIA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;AACnB;;;;;AAKA;IACI;;6BAEyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,WAAW;IACX,6BAA6B;IAC7B,+BAA+B;IAC/B,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;IAC/B,kBAAkB;IAClB,iCAAiC;IACjC,oBAAoB;IACpB,gBAAgB;IAChB,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;AACA;AACA,aAAa;AACb,YAAY;AACZ,aAAa;AACb,sBAAsB;AACtB,mBAAmB;AACnB,uBAAuB;AACvB,+BAA+B;AAC/B,kBAAkB;AAClB,iCAAiC;AACjC,oBAAoB;AACpB,gBAAgB;AAChB,SAAS;AACT,iBAAiB;AACjB,iBAAiB;AACjB,cAAc;AACd;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;IAC/B,kBAAkB;IAClB,iCAAiC;IACjC,oBAAoB;IACpB,gBAAgB;IAChB,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B;;AAEJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,0CAA0C;IAC1C,eAAe;AACnB;;AAEA,iCAAiC;AACjC;IACI,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,wBAAwB;IACxB,cAAc;AAClB;AACA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,oCAAoC;IACpC,uBAAuB;IACvB,sBAAsB;IACtB,+BAA+B;AACnC;AACA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,kCAAkC;IAClC,uBAAuB;IACvB,wBAAwB;IACxB,oCAAoC;IACpC,+BAA+B;AACnC;;;AAGA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,0BAA0B;IAC1B,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,4BAA4B;IAC5B,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B","sourcesContent":[".leaveapplyfirstdiv{\r\n    font-family: \"Inter\";\r\nfont-size: 18px;\r\nfont-weight: 600;\r\ntext-align: left;\r\nalign-items: center;\r\ncolor: #0070E9;\r\n/* padding-left: 2%; */\r\n/* padding-top: 2%; */\r\n\r\n}\r\n\r\n.leavereqSelectedTotalMain{\r\n    justify-content: center;\r\n    text-align: center;\r\n    align-items: center;\r\n    margin: auto;\r\n    \r\n}\r\n\r\n.leavereqSelectDates{\r\n    font-family: \"Inter\";\r\nfont-size: 16px;\r\nfont-weight: 600;\r\nline-height: 21.78px;\r\nletter-spacing: 0.02em;\r\ntext-align: left;\r\ncolor:#002C5D;\r\njustify-content: center;\r\ntext-align: center;\r\n\r\n}\r\n\r\n.leftarrowinapply{\r\n    width: 6px !important;\r\nheight: 12px !important;\r\ntop: 6px;\r\nleft: 9px;\r\ngap: 0px;\r\nfont-size: 12px !important;\r\nborder: 2px 0px 0px 0px;\r\n\r\n color:#002C5D !important;\r\ncursor:pointer\r\n}\r\n\r\n.headinginfromInapply1{\r\n    color: #0070E9 !important;\r\n    font-family:\"Inter\";\r\nfont-size: 16px;\r\nfont-weight: 600;\r\nline-height: 19.36px;\r\ntext-align: center;\r\nalign-items: center !important;\r\n/* padding-top: 3%; */\r\n}\r\n\r\n.fromInapply1{\r\n    font-family: \"Inter\";\r\nfont-size: 16px;\r\nfont-weight: 600;\r\nline-height: 19.36px;\r\ntext-align: center;\r\ncolor:#002C5D ;\r\nalign-items: center !important;\r\n}\r\n\r\n.leaveApplyTotaldaysMain{\r\n    display: flex;\r\n    gap:2%;\r\n    align-items: center;\r\n    text-align: center;\r\n    justify-content: center;\r\n\r\n\r\n}\r\n\r\n.leaveApplyTotaldaystotal{\r\n    font-family: \"Inter\";\r\nfont-size: 16px;\r\nfont-weight: 600;\r\n/* line-height: 19.36px; */\r\ntext-align: left;\r\ncolor:#002C5D;\r\njustify-content: center;\r\ntext-align: center;\r\n\r\n}\r\n\r\n.leavereqTotalDays{\r\n    font-family: \"Inter\";\r\nfont-size: 20px;\r\nfont-weight: 600;\r\nline-height: 24.2px;\r\ntext-align: left;\r\ncolor:#0070E9;\r\n\r\n\r\n}\r\n\r\n.leavereq2ndiv3rdcol{\r\n    display:flex;\r\n    gap:4%;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-align: center;\r\n\r\n}\r\n\r\n.levreqDate{\r\n    font-family: \"Inter\";\r\nfont-size: 16px;\r\nfont-weight: 700;\r\nline-height: 19.36px;\r\ntext-align: left;\r\ncolor:#0070E9;\r\n\r\n\r\n}\r\n\r\n\r\n.calenderreactmain{\r\n    display: flex;\r\n    gap:4%;\r\n    justify-content: center;\r\n    text-align: center;\r\n    align-items: center;\r\n    margin: auto;\r\n    padding-top: 5%;\r\n    /* padding-bottom: 3%; */\r\n    \r\n\r\n}\r\n\r\n.react-calendar { \r\n    width: 100%;\r\n    max-width: 420px;\r\n    background-color: #fff;\r\n    color: #222;\r\n    border-radius: 8px;\r\n    /* box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2); */\r\n    font-family: Arial, Helvetica, sans-serif;\r\n    line-height: 1.125em;\r\n    /* border: none !important; */\r\n    border:1px solid #E9E9E9;\r\n    padding: 10px;\r\n\r\n   }\r\n   .react-calendar__navigation button {\r\n    color: #6f48eb;\r\n    min-width: 44px;\r\n    background: none;\r\n    font-size: 16px;\r\n    margin-top: 8px;\r\n   }\r\n   .react-calendar__navigation button:enabled:hover,\r\n   .react-calendar__navigation button:enabled:focus {\r\n    background-color: #f8f8fa;\r\n   }\r\n   .react-calendar__navigation button[disabled] {\r\n    background-color: #f0f0f0;\r\n   }\r\n   abbr[title] {\r\n    text-decoration: none;\r\n   }\r\n   /* .react-calendar__month-view__days__day--weekend {\r\n    color: #d10000;\r\n   } */\r\n   .react-calendar__tile:enabled:hover,\r\n   .react-calendar__tile:enabled:focus {\r\n    background: #f8f8fa;\r\n    color: #6f48eb;\r\n    border-radius: 6px;\r\n   }\r\n   .react-calendar__tile--now {\r\n    background: #6f48eb33;\r\n    border-radius: 6px;\r\n    font-weight: bold;\r\n    color: #6f48eb;\r\n   }\r\n   .react-calendar__tile--now:enabled:hover,\r\n   .react-calendar__tile--now:enabled:focus {\r\n    background: #6f48eb33;\r\n    border-radius: 6px;\r\n    font-weight: bold;\r\n    color: #6f48eb;\r\n   }\r\n   .react-calendar__tile--hasActive:enabled:hover,\r\n   .react-calendar__tile--hasActive:enabled:focus {\r\n    background: #f8f8fa;\r\n   }\r\n   .react-calendar__tile--active {\r\n    background: #6f48eb;\r\n    border-radius: 6px;\r\n    font-weight: bold;\r\n    color: white;\r\n   }\r\n   .react-calendar__tile--active:enabled:hover,\r\n   .react-calendar__tile--active:enabled:focus {\r\n    background: #6f48eb;\r\n    color: white;\r\n   }\r\n   .react-calendar--selectRange .react-calendar__tile--hover {\r\n    background-color: #f8f8fa;\r\n   }\r\n   .react-calendar__tile--range {\r\n    background: #f8f8fa;\r\n    color: #6f48eb;\r\n    border-radius: 0;\r\n   }\r\n   .react-calendar__tile--rangeStart {\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    border-top-left-radius: 6px;\r\n    border-bottom-left-radius: 6px;\r\n    background: #6f48eb;\r\n    color: white;\r\n   }\r\n   .react-calendar__tile--rangeEnd {\r\n    border-top-left-radius: 0;\r\n    border-bottom-left-radius: 0;\r\n    border-top-right-radius: 6px;\r\n    border-bottom-right-radius: 6px;\r\n    background: #6f48eb;\r\n    color: white;\r\n   }\r\n\r\n   .react-calendar__month-view__weekdays{\r\n    font-family: \"Inter\";\r\nfont-size: 12px;\r\nfont-weight: 500;\r\nline-height: 12px;\r\nletter-spacing: 0.03em;\r\ntext-align: left;\r\ncolor:#00162E\r\n\r\n   }\r\n\r\n\r\n\r\n   .react-calendar__month-view__days__day--weekend{\r\n    font-family: \"Inter\";\r\nfont-size: 12px;\r\nfont-weight: 500;\r\nline-height: 22px;\r\ntext-align: center;\r\ncolor:#E90000;\r\nbackground-color: #E9000033;\r\nborder-radius: 100%;\r\npadding-top: 10px;\r\npadding-bottom: 10px;\r\n\r\n\r\n   }\r\n\r\n   .react-calendar__month-view__days{\r\n    padding-top: 5px;\r\n    padding-bottom: 10px;\r\n   }\r\n   .react-calendar__navigation__arrow.react-calendar__navigation__prev-button{\r\n    color:#002C5D;\r\n    font-size:12px;\r\n   }\r\n\r\n   .react-calendar__month-view__days button{\r\n    height:44px;\r\n    /* width:100%; */\r\n    width: 40px;\r\n    margin-top: 5px;\r\n    border-radius: 50%;\r\n   }\r\n\r\n\r\n   .colors-label-detailing{\r\n    display: flex;\r\n    /* text-align: center; */\r\n    align-items: center;\r\n    justify-content: center;\r\n    /* padding-left: 3%; */\r\n   }\r\n\r\n   .Selected-Leavegrid{\r\n    font-family: \"Inter\";\r\nfont-size: 14px;\r\nfont-weight: 700;\r\nline-height: 16.94px;\r\nletter-spacing: 0.02em;\r\ntext-align: left;\r\ncolor:#0070E9\r\n\r\n   }\r\n   .privilizedleavegrid{\r\n    font-family: \"Inter\";\r\n    font-size: 14px;\r\n    font-weight: 700;\r\n    line-height: 16.94px;\r\n    letter-spacing: 0.02em;\r\n    text-align: left;\r\n    color:#008A27\r\n\r\n   }\r\n\r\n   .Optinalleavegrid{\r\n    font-family: \"Inter\";\r\n    font-size: 14px;\r\n    font-weight: 700;\r\n    /* line-height: 16.94px; */\r\n    letter-spacing: 0.02em;\r\n    text-align: left;\r\n    justify-content: left;\r\n    color:grey\r\n\r\n   }\r\n   .Sick-Leave-grid{\r\n    font-family: \"Inter\";\r\n    font-size: 14px;\r\n    font-weight: 700;\r\n    line-height: 16.94px;\r\n    letter-spacing: 0.02em;\r\n    text-align: left;\r\n    color:#E97000;\r\n    margin-left: 0;\r\n\r\n\r\n   }\r\n\r\n   .Holidaygrid{\r\n    font-family: \"Inter\";\r\n    font-size: 14px;\r\n    font-weight: 700;\r\n    line-height: 16.94px;\r\n    letter-spacing: 0.02em;\r\n    text-align: left;\r\n    color:#E90000\r\n\r\n   }\r\n\r\n   .react-calendar button {\r\n    font-family: \"Inter\";\r\nfont-size: 18px;\r\nfont-weight: 500;\r\nline-height: 22px;\r\ntext-align: center;\r\nwidth:19px;\r\n/* color:#00162E; */\r\n/* margin: 10px; */\r\n\r\n   }\r\n\r\n\r\n\r\n\r\n   /* new */\r\n\r\n\r\n.LeaveApplyCalenderContainer{\r\n    display: flex;\r\n    justify-content: space-around;\r\n    gap: 10px;\r\n}\r\n   .calendarInapply {\r\n    /* display: flex;\r\n    justify-content: space-around;\r\n    flex-direction: row; */\r\n    align-items: center;\r\n    border: 1px solid #E9E9E9;\r\n    /* margin:10px; */\r\n    width:40%\r\n}\r\n\r\n.calendar-headerInapply1 {\r\n    display: flex;\r\n    /* width: 100%; */\r\n    justify-content: space-around;\r\n    /* background-color: #f0f0f0; */\r\n    padding: 10px;\r\n    align-items: center !important;\r\n}\r\n\r\n.calendar-header-dayInapply1 {\r\n    width: 12.28%;\r\n    text-align: center;\r\n    font-weight: bold;\r\n}\r\n\r\n.calendar-bodyInapply1 {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    /* height:100vh; */\r\n}\r\n\r\n.calendar-weekInapply1 {\r\n    display: flex;\r\n    width: 100%;\r\n    height: 50px;\r\n    /* padding-bottom: 1%; */\r\n}\r\n\r\n\r\n\r\n.calendar-dayInapply1 :hover{\r\n    border: 1px solid #0070E9;\r\n    background-color: grey;\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n\r\n\r\n.calendarInapply2 {\r\n    /* display: flex;\r\n    justify-content: space-around;\r\n    flex-direction: column; */\r\n    align-items: center;\r\n    border: 1px solid #E9E9E9;\r\n    /* margin:10px; */\r\n    width:40%\r\n}\r\n\r\n.calendar-headerInapply2 {\r\n    display: flex;\r\n    width: 100%;\r\n    justify-content: space-around;\r\n    /* background-color: #f0f0f0; */\r\n    padding: 10px;\r\n}\r\n\r\n.calendar-header-dayInapply2 {\r\n    width: 7.14%;\r\n    text-align: center;\r\n    font-weight: bold;\r\n}\r\n\r\n.calendar-bodyInapply2 {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    /* height:100vh; */\r\n}\r\n\r\n.calendar-weekInapply2 {\r\n    display: flex;\r\n    width: 100%;\r\n}\r\n\r\n.calendar-dayInapply1 {\r\n    width: 12.28%;\r\n    height: 47px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    /* border: 1px solid #f0f0f0; */\r\n    position: relative;\r\n    transition: background-color 0.3s;\r\n    border-radius: 100px;\r\n    margin-top: 10px;\r\n    gap: 10px;\r\n    margin-right: 5px;\r\n    margin-bottom: 3%;\r\n    margin: 0 auto;\r\n}\r\n.calendar-dayInapply12{\r\nwidth: 12.28%;\r\nheight: 47px;\r\ndisplay: flex;\r\nflex-direction: column;\r\nalign-items: center;\r\njustify-content: center;\r\n/* border: 1px solid #f0f0f0; */\r\nposition: relative;\r\ntransition: background-color 0.3s;\r\nborder-radius: 100px;\r\nmargin-top: 10px;\r\ngap: 10px;\r\nmargin-right: 5px;\r\nmargin-bottom: 3%;\r\nmargin: 0 auto;\r\n}\r\n\r\n.calendar-dayInapply12 {\r\n    width: 12.28%;\r\n    height: 47px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    /* border: 1px solid #f0f0f0; */\r\n    position: relative;\r\n    transition: background-color 0.3s;\r\n    border-radius: 100px;\r\n    margin-top: 10px;\r\n    gap: 10px;\r\n    margin-right: 5px;\r\n    margin-bottom: 3%;\r\n    margin: 0 auto;\r\n}\r\n\r\n.weekendInapply1 {\r\n    background-color: #E9000033;\r\n    color:#E90000;\r\n}\r\n\r\n.holidayInapply1 {\r\n    background-color: #008A2733;\r\n    color:#008A27\r\n\r\n}\r\n\r\n.holiday-nameInapply1 {\r\n    position: absolute;\r\n    bottom: 5px;\r\n    font-size: 0.75em;\r\n    text-align: center;\r\n    width: 100%;\r\n}\r\n\r\n.calendar-dayInapply1:hover {\r\n    border: 1px solid #0070E9;\r\n    /* background-color: rgb(192, 187, 187); */\r\n    cursor: pointer;\r\n}\r\n\r\n/* Adjust specificity if needed */\r\n.calendar-dayInapply1.selected {\r\n    background-color: #0070E9;\r\n    color: white;\r\n}\r\n.modalButtonContainer{\r\n    justify-content: center;\r\n    display: flex;\r\n    text-align: center;\r\n    /* gap: 3% !important; */\r\n    margin-top: 4%;\r\n}\r\n.leaveApplyModalConfirm{\r\n    font-family: \"Inter\" !important;\r\n    font-size: 14px !important;\r\n    font-weight: 600 !important;\r\n    background-color: #FE602F !important;\r\n    border: none !important;\r\n    color:white !important;\r\n    text-transform: none !important;\r\n}\r\n.leaveApplyModalCancel{\r\n    font-family: \"Inter\" !important;\r\n    font-size: 14px !important;\r\n    font-weight: 600 !important;\r\n    background-color: white !important;\r\n    border: none !important;\r\n    color:#FE602F !important;\r\n    border: 1px solid #FE602F !important;\r\n    text-transform: none !important;\r\n}\r\n\r\n  \r\n.modalselectedDates{\r\n    background-color: #f7fbff;\r\n    border-radius: 10px;\r\n    border: 1px dashed #dce4ed;\r\n    padding: 20px;\r\n    width:100%;\r\n    text-align: center;\r\n    max-height: 650px;\r\n    overflow-y: auto;\r\n}\r\n\r\n.labelforselectDates{\r\n    font-family: \"Inter\";\r\n    font-size: 16px;\r\n    font-weight: 550;\r\n    line-height: 19px;\r\n    /* letter-spacing: 0.02em; */\r\n    text-align: left;\r\n    color:#0056B2;\r\n    padding-left: 10px;\r\n    /* padding-bottom: 5px; */\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
